import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Row,
  Col,
  Card,
  Form,
  Dropdown,
} from "react-bootstrap";
import {
  FaEllipsisV,
  FaFileAlt,
  FaFileAudio,
  FaFileVideo,
  FaRegSmile,
  FaTrash,
  FaTrashAlt,
} from "react-icons/fa";
import Picker from "emoji-picker-react";
import SimpleBar from "simplebar-react";
import { MdAdd, MdAddToPhotos, MdClose } from "react-icons/md";
import {
  RiChatNewLine,
  RiInsertRowTop,
  RiOpenaiFill,
  RiRepeatLine,
  RiSparklingFill,
} from "react-icons/ri";
import RenameModal from "./renameContentPanel";
import DeleteModal from "./deleteContentPanel";
import { RiAiGenerate } from "react-icons/ri";

const PanelContent = ({
  allContent,
  setAllContent,
  headers,
  selectedRep,
  functionDropdown,
}) => {
  const pickerRef = useRef(null);
  const [selectedItem, setSelectedItem] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [activeBubbleIndex, setActiveBubbleIndex] = useState(null);
  const [selectedContent, setSelectedContent] = useState(allContent[0]);
  const fileInputRef = useRef({}); // Tambahkan useRef

  const handleClickUpload = (bubbleId) => {
    if (fileInputRef.current[bubbleId]) {
      fileInputRef.current[bubbleId].click();
    }
  };

  const handleFileChange = (event, bubbleId) => {
    const newFiles = Array.from(event.target.files);

    setAllContent((prev) =>
      prev.map((item) =>
        item.id === selectedContent.id
          ? {
              ...item,
              content: item.content.map((bubble) =>
                bubble.id === bubbleId
                  ? {
                      ...bubble,
                      file: newFiles[0] || bubble.file, // Simpan hanya satu file (terbaru)
                    }
                  : bubble
              ),
            }
          : item
      )
    );

    event.target.value = ""; // Reset input file agar bisa upload file yang sama lagi
  };

  const handleRemoveFile = (bubbleId) => {
    if (!selectedContent) return;

    setAllContent((prev) =>
      prev.map((item) =>
        item.id === selectedContent.id
          ? {
              ...item,
              content: item.content.map((bubble) =>
                bubble.id === bubbleId
                  ? {
                      ...bubble,
                      file: null, // Hapus file dengan mengatur null
                    }
                  : bubble
              ),
            }
          : item
      )
    );
  };

  // Emoticon
  useEffect(() => {
    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  // Auto resize textarea
  const handleEmojiClick = (emojiData) => {
    insertDataFunction(emojiData.emoji);
  };

  // Auto resize textarea
  const textareaRef = useRef([]);
  const simpleBarRef = useRef(null);
  const simpleBarRef2 = useRef(null);
  const autoResize = (el) => {
    if (!el || !simpleBarRef2.current) return;
    const scrollEl = simpleBarRef2.current.getScrollElement();
    // Simpan posisi scroll sebelum textarea diperbesar
    const prevScrollTop = scrollEl.scrollTop;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
    // Kembalikan posisi scroll ke tempat semula
    scrollEl.scrollTop = prevScrollTop;
  };

  // Resize textarea & pertahankan posisi scroll saat pindah content
  useEffect(() => {
    setTimeout(() => {
      if (simpleBarRef2.current) {
        requestAnimationFrame(() => {
          const scrollElement = simpleBarRef2.current.getScrollElement();
          if (scrollElement) {
            scrollElement.scrollTop = 0;
          }
        });
      }
      textareaRef.current.forEach((el) => el && autoResize(el));
    }, 10);
  }, [selectedContent?.id]);

  // Ganti content
  const handleContentChange = (data) => {
    setSelectedContent(data);
    setActiveBubbleIndex(null); // Reset active bubble saat ganti content
  };

  // Edit bubble tertentu
  const handleMessageChange = (index, value) => {
    if (selectedContent) {
      setAllContent((prev) =>
        prev.map((item) =>
          item.id === selectedContent.id
            ? {
                ...item,
                content: item.content.map((bubble, idx) =>
                  idx === index ? { ...bubble, text: value } : bubble
                ),
              }
            : item
        )
      );
      setActiveBubbleIndex(index);
    }
  };

  /* Insert Data Function */
  const insertDataFunction = (text) => {
    if (selectedContent && activeBubbleIndex !== null) {
      const textarea = textareaRef.current[activeBubbleIndex]; // Ambil textarea aktif
      const cursorPos = textarea.selectionStart; // Simpan posisi cursor

      setAllContent((prev) =>
        prev.map((item) =>
          item.id === selectedContent.id
            ? {
                ...item,
                content: item.content.map((bubble, idx) =>
                  idx === activeBubbleIndex
                    ? {
                        ...bubble,
                        text:
                          (bubble.text || "").slice(0, cursorPos) +
                          text +
                          (bubble.text || "").slice(cursorPos),
                      }
                    : bubble
                ),
              }
            : item
        )
      );

      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(
          cursorPos + text.length,
          cursorPos + text.length
        );
      }, 0);
    }
  };

  const handleAddVariant = () => {
    setAllContent((prevContent) => {
      // Cari variant dengan id: 1
      const baseVariant = prevContent.find(
        (item) => item.name === "Default Variant"
      );

      // Salin semua bubble dari variant id: 1 jika ditemukan, jika tidak, gunakan array kosong
      const newContent = baseVariant
        ? baseVariant.content.map((bubble) => ({ ...bubble }))
        : [];

      // Cari ID terbesar saat ini dan tambahkan 1 untuk memastikan ID unik
      const newId =
        prevContent.length > 0
          ? Math.max(...prevContent.map((item) => item.id)) + 1
          : 1;

      return [
        ...prevContent,
        {
          id: newId,
          name: `Variant ${newId}`,
          content: newContent, // Gunakan copy dari content id: 1
        },
      ];
    });

    // Tunggu render selesai sebelum scroll
    setTimeout(() => {
      if (simpleBarRef.current) {
        const scrollElement = simpleBarRef.current.getScrollElement();
        scrollElement.scrollTop = scrollElement.scrollHeight;
      }
    }, 0);
  };

  // Tambah bubble
  const handleAddBubble = () => {
    if (selectedContent) {
      const newBubble = {
        id: Date.now(), // ID unik agar tidak bentrok
        text: "",
        file: null,
      };

      setAllContent((prev) =>
        prev.map((item) =>
          item.id === selectedContent.id
            ? { ...item, content: [...item.content, newBubble] }
            : item
        )
      );

      // Buat referensi baru untuk file input dari bubble yang baru
      fileInputRef.current[newBubble.id] = null;

      // Tunggu render selesai sebelum scroll
      setTimeout(() => {
        if (simpleBarRef2.current) {
          const scrollElement = simpleBarRef2.current.getScrollElement();
          scrollElement.scrollTop = scrollElement.scrollHeight;
        }
      }, 0);
    }
  };

  // Hapus bubble
  const handleDeleteBubble = (bubbleId) => {
    if (selectedContent) {
      setAllContent((prev) =>
        prev.map((item) =>
          item.id === selectedContent.id
            ? {
                ...item,
                content: item.content.filter(
                  (bubble) => bubble.id !== bubbleId
                ),
              }
            : item
        )
      );

      // Hapus referensi file input dari bubble yang dihapus
      if (fileInputRef.current) {
        delete fileInputRef.current[bubbleId];
      }

      setActiveBubbleIndex(null);
    }
  };

  // Gunakan useEffect untuk memastikan selectedContent selalu terupdate
  useEffect(() => {
    if (selectedContent) {
      const updated = allContent.find((item) => item.id === selectedContent.id);
      if (updated) {
        setSelectedContent(updated);
      }
    }
  }, [allContent]);

  /* =============================================================== */
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  // Fungsi Rename
  const handleRename = (newName) => {
    setAllContent((prev) => {
      const matchingNames = prev
        .map((el) => el.name)
        .filter((name) => name.startsWith(newName));

      let uniqueName = newName;

      if (matchingNames.includes(newName)) {
        let maxNumber = 0;
        matchingNames.forEach((name) => {
          const match = name.match(/\[(\d+)\]$/);
          if (match) {
            const num = parseInt(match[1], 10);
            if (num > maxNumber) maxNumber = num;
          }
        });
        uniqueName = `${newName} [${maxNumber + 1}]`;
      }

      return prev.map((el) =>
        el.id === selectedItem.id ? { ...el, name: uniqueName } : el
      );
    });
    setShowRenameModal(false);
  };

  // Fungsi Delete
  const handleDelete = () => {
    setAllContent((prev) => prev.filter((el) => el.id !== selectedItem.id));
    setShowDeleteModal(false);
  };

  useEffect(() => {
    if (selectedItem) {
      if (selectedItem.action === "rename") {
        setShowRenameModal(true);
      } else if (selectedItem.action === "delete") {
        setShowDeleteModal(true);
      }
    }
  }, [selectedItem]);

  const fileSrc = (item) => {
    return item.file instanceof File
      ? URL.createObjectURL(item.file)
      : item.file?.url ?? "";
  };

  return (
    <Container fluid className="p-3 px-4 border rounded bg-light">
      <Row>
        {/* Panel Kiri dengan Scroll */}
        <Col
          md={3}
          className="border-end p-3 bg-white d-flex flex-column"
          style={{ height: "70vh" }}
        >
          <h6>Message Variant</h6>
          <hr />
          <div className="d-flex justify-content-between gap-2">
            <Button
              variant="primary"
              className="border w-100"
              onClick={handleAddVariant}
              title="Add Variant"
            >
              <RiAiGenerate size={21} />
            </Button>
            <Button
              variant="primary"
              className="border w-100"
              title="Add Smart Variant"
            >
              <RiSparklingFill size={18} />
            </Button>
            <Button
              variant="orange"
              className="border w-100"
              title="Re-generate Variant"
            >
              <RiRepeatLine size={18} />
            </Button>
            <Button
              variant="danger"
              className="border w-100"
              title="Delete All Variant"
            >
              <FaTrashAlt size={16} />
            </Button>
          </div>
          <hr />
          <SimpleBar ref={simpleBarRef} style={{ height: "50vh", flexGrow: 1 }}>
            <ul className="list-group">
              {allContent.map((item, index) => (
                <li
                  key={index}
                  className="d-flex justify-content-between align-items-center mb-2 p-2 border border-1"
                  onClick={() => handleContentChange(item)}
                  style={{
                    backgroundColor:
                      selectedContent.id === item.id ? "#ffd284" : null,
                    color: selectedContent.id === item.id ? "#333" : null,
                    cursor: "pointer",
                    borderRadius: "6px",
                  }}
                >
                  <span>{index > 0 ? item.name : "Default Variant"}</span>
                  {index > 0 && (
                    <Dropdown
                      show={openDropdownId === item.id}
                      onClick={(e) => e.stopPropagation()}
                      onToggle={(isOpen) =>
                        setOpenDropdownId(isOpen ? item.id : null)
                      } // Supaya klik dropdown tidak trigger list item
                    >
                      <Dropdown.Toggle
                        variant="light"
                        className="border insert btn-sm px-1 py-0"
                      >
                        <FaEllipsisV />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        style={{
                          position: "absolute",
                          zIndex: "1050 !important",
                        }}
                      >
                        <Dropdown.Item
                          onClick={() =>
                            setSelectedItem({ ...item, action: "rename" })
                          }
                        >
                          Rename
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() =>
                            setSelectedItem({ ...item, action: "delete" })
                          }
                          className="text-danger"
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </li>
              ))}
              {/* Modal Rename */}
              {selectedItem && (
                <RenameModal
                  show={showRenameModal}
                  handleClose={() => setShowRenameModal(false)}
                  handleRename={handleRename}
                  item={selectedItem}
                />
              )}

              {/* Modal Delete */}
              {selectedItem && (
                <DeleteModal
                  show={showDeleteModal}
                  handleClose={() => setShowDeleteModal(false)}
                  handleDelete={handleDelete}
                  item={selectedItem}
                />
              )}
            </ul>
          </SimpleBar>
        </Col>

        {/* Panel Konten dengan Scroll */}
        <Col
          md={9}
          className="border-end p-3 bg-white d-flex flex-column"
          style={{ height: "70vh" }}
        >
          {selectedContent && <h6>Message Template</h6>}
          <SimpleBar
            ref={simpleBarRef2}
            style={{ maxHeight: "60vh", flexGrow: 1 }}
          >
            <div
              className="p-3"
              style={{ minHeight: "60vh", backgroundColor: "#F1F4F7" }}
            >
              {selectedContent &&
                allContent
                  .find((item) => item.id === selectedContent.id)
                  ?.content.map((item, index) => (
                    <Card key={item.id} className="mb-3">
                      <Card.Body>
                        <div className="d-flex justify-content-between mb-2">
                          <Card.Title>
                            <p className="h4 mb-0">Chat Bubble {index + 1}</p>
                          </Card.Title>
                          {selectedContent.content.length > 1 && (
                            <a
                              className="btn btn-danger rounded-2"
                              size="sm"
                              onClick={() => handleDeleteBubble(item.id)}
                            >
                              <FaTrash />
                            </a>
                          )}
                        </div>
                        <Form>
                          {/* Insert File */}
                          <div className="d-block">
                            <div className="text-center d-flex flex-column align-items-center">
                              {/* Tombol Upload (Hidden Input File) */}
                              <input
                                type="file"
                                ref={(el) => {
                                  if (el) fileInputRef.current[item.id] = el; // Pastikan el tidak null
                                }}
                                onChange={(e) => handleFileChange(e, item.id)} // Kirim ID bubble
                                style={{ display: "none" }}
                              />
                              <label
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center rounded-circle p-0 mb-1"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  aspectRatio: "1/1",
                                }}
                                title="Add File"
                                onClick={() => handleClickUpload(item.id)} // Pastikan onClick mengakses ref bubble yang benar
                              >
                                <MdAddToPhotos size={18} />
                              </label>
                            </div>
                          </div>
                          <div className="d-block text-center">
                            {item.file && (
                              <div
                                className="card m-0 border border-1"
                                style={{
                                  display: "inline-block",
                                  position: "relative",
                                  overflow: "hidden",
                                }}
                              >
                                {/* Tombol Hapus */}
                                <a
                                  className="btn btn-danger btn-sm position-absolute"
                                  style={{
                                    top: "5px",
                                    right: "5px",
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                    padding: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={() => handleRemoveFile(item.id)} // Hapus file dari bubble
                                >
                                  <MdClose />
                                </a>

                                {item.file.type.startsWith("image/") ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      width: "100%",
                                      height: "auto",
                                    }}
                                  >
                                    <img
                                      src={fileSrc(item)}
                                      alt={item.file.name}
                                      className="card-img-top"
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "250px",
                                        height: "auto",
                                        width: "auto",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                ) : item.file.type.startsWith("audio/") ? (
                                  <div className="card-body text-center px-2">
                                    <p className="card-text small fw-bold">
                                      <FaFileAudio size={16} className="mb-1" />
                                      <br />
                                      {item.file.name}
                                    </p>
                                  </div>
                                ) : item.file.type.startsWith("video/") ? (
                                  <div className="card-body text-center px-2">
                                    <p className="card-text small fw-bold">
                                      <FaFileVideo size={16} className="mb-1" />
                                      <br />
                                      {item.file.name}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="card-body text-center px-2">
                                    <p className="card-text small fw-bold">
                                      <FaFileAlt size={16} className="mb-1" />
                                      <br />
                                      {item.file.name}
                                    </p>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <Form.Control
                            // key={selectedContent.id}
                            ref={(el) => (textareaRef.current[index] = el)}
                            as="textarea"
                            rows={4}
                            placeholder="Write your message"
                            value={item.text}
                            onChange={(e) =>
                              handleMessageChange(index, e.target.value)
                            }
                            onFocus={() => setActiveBubbleIndex(index)}
                            onInput={(e) => autoResize(e.target)}
                            className="mt-1"
                            style={{ overflow: "hidden", resize: "vertical" }}
                          />
                        </Form>
                      </Card.Body>
                    </Card>
                  ))}
            </div>
          </SimpleBar>
          <div className="d-flex justify-content-between mt-2">
            {selectedContent && (
              <>
                <div>
                  <Col className="d-flex align-items-center">
                    {/* Tombol Emoticon */}
                    <a
                      title="Emoticon"
                      className="btn btn-primary btn-rounded rounded-4 px-1 py-1 me-2"
                      onClick={() => setShowPicker((prev) => !prev)}
                      onMouseDown={(e) => e.preventDefault()}
                      style={{ zIndex: 1 }}
                    >
                      <FaRegSmile size={20} />
                    </a>

                    {/* Dropdown */}
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle
                        variant="primary"
                        className="btn btn-primary btn-rounded insert rounded-4 px-1 py-1"
                        data-bs-popper="static"
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        <RiInsertRowTop size={20} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        flip={false}
                        className="custom-dropdown-menu"
                      >
                        <div className="dropdown-scroll">
                          {headers.length > 0 ? (
                            headers.map((header, index) => (
                              <Dropdown.Item
                                key={index}
                                onClick={() =>
                                  insertDataFunction(`{{${header}}}`)
                                }
                              >
                                {header}
                              </Dropdown.Item>
                            ))
                          ) : selectedRep.length > 0 ? (
                            functionDropdown.length > 0 ? (
                              functionDropdown.map((header, index) => (
                                <Dropdown.Item
                                  key={index}
                                  onClick={() =>
                                    insertDataFunction(`{{${header}}}`)
                                  }
                                >
                                  {header}
                                </Dropdown.Item>
                              ))
                            ) : (
                              <Dropdown.Item disabled>No Data</Dropdown.Item>
                            )
                          ) : (
                            <Dropdown.Item disabled>No Data</Dropdown.Item>
                          )}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Tombol Add Bubble */}
                    {selectedContent.name === "Default Variant" && (
                      <a
                        title="Add Bubble"
                        className="btn btn-primary btn-rounded rounded-4 px-1 py-1"
                        onClick={handleAddBubble}
                        onMouseDown={(e) => e.preventDefault()}
                        style={{ zIndex: 1 }}
                      >
                        <RiChatNewLine size={18} />
                      </a>
                    )}
                  </Col>
                </div>

                {/* Tombol Save Variant */}
                <div>
                  {/* <Col className="text-end">
                    <a onClick={""} className="btn btn-success">
                      Save Variant
                    </a>
                  </Col> */}
                </div>
              </>
            )}

            {/* Emoji Picker */}
            {showPicker && (
              <div
                ref={pickerRef}
                className="emoji-picker-container"
                style={{ bottom: "480px" }}
              >
                <Picker onEmojiClick={handleEmojiClick} />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PanelContent;
